import React from 'react';
import BuyInformation from './BuyInformation/BuyInformation';
import SubscribeApis from './SubscribeApis/SubscribeApis';
import './Overview.scss';

const PAGES = {
  BUY_INFORMATION: 'buy-information',
  SUBSCRIBE: 'subscribe',
} as const;

const Overview = ({
  pageName,
}: {
  pageName: (typeof PAGES)[keyof typeof PAGES];
}) => {
  return (
    <div className="overview-page">
      {pageName === PAGES.BUY_INFORMATION && <BuyInformation />}
      {pageName !== PAGES.BUY_INFORMATION && <SubscribeApis />}
    </div>
  );
};

export default Overview;
